export function getCookie(name: string) {
  if (typeof document === 'undefined' || !document.cookie) {
    console.error('Cookies are not available in this environment.');
    return null;
  }

  const cookies = document.cookie.split('; ');
  for (const cookieStr of cookies) {
    const cookie = cookieStr.split('=');
    if (cookie[0] === name) {
      return cookie[1].toString();
    }
  }
  return '';
}
